'use client';
import Link from 'next/link';
import { MouseEvent } from 'react';

interface HeaderMenuItemProps {
  characters: string;
  href?: string;
  isActive?: boolean;
  text_font_size?: string;
  text_font_family?: string;
  text_font_weight?: string;
  text_line_height?: string;
  letter_spacing?: string;
  text_color?: string;
  background?: string;
  effect_box_shadow?: string;
  className?: string;
  onClick?: () => void;
}

const HeaderMenuItem = ({
  characters,
  href = "#",
  isActive = false,
  text_font_size = "text-lg",
  text_font_family = "Gotham",
  text_font_weight = "font-medium",
  text_line_height = "leading-normal",
  letter_spacing = "tracking-[1px]",
  text_color = "text-header-text",
  background,
  effect_box_shadow,
  className = "",
  onClick
}: HeaderMenuItemProps) => {
  
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault()
      onClick()
    }
  }

  const baseClasses = `
    ${text_font_size} 
    ${text_font_weight} 
    ${text_line_height} 
    ${letter_spacing}
    ${isActive ? 'bg-gradient-to-r from-[#ff00cc] to-[#fc4a1a] bg-clip-text text-transparent' : text_color}
    ${effect_box_shadow || ''}
    hover:opacity-80 
    transition-all 
    duration-200 
    cursor-pointer
    ${className}
  `.trim()

  const customStyles = {
    fontFamily: text_font_family === 'Gotham' ? 'Gotham, sans-serif' : text_font_family,
    ...(background && isActive && !background.includes('gradient') && { background }),
  }

  return (
    <Link data-component-id="src/components/ui/HeaderMenuItem.tsx:64:4" data-component-path="src/components/ui/HeaderMenuItem.tsx" data-component-line="64" data-component-end-line="72" data-component-file="HeaderMenuItem.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%2C%22className%22%3A%22%5Bvar%3AbaseClasses%5D%22%7D" 
      href={href}
      onClick={handleClick}
      className={baseClasses}
      style={customStyles}
      role="menuitem"
    >
      {characters}
    </Link>
  )
}

export default HeaderMenuItem